import { ETimeUnit } from '@hooks'

import { SearchFilterForm } from '../AddSearchFilterDialog'

export const getDefaultValues = (): SearchFilterForm => {
  return {
    code: '',
    title: '',
    objectTitle: '',
    isPinning: false,
    // value: [{ id: 0, label: i18next.t('searchFilterForm.value.placeholder') }],
    // fieldType: i18next.t('searchFilterForm.fieldType.placeholder'),
    // objectValue: i18next.t('searchFilterForm.objectValue.placeholder'),
    values: [
      {
        name: null,
        fieldType: null,
        formatDate: null,
        objectValue: '',
        linkedObjectCode: '',
        isDefaultPlaceholder: true,
        placeholderValue: '',
        placeholderEnd: '',
        placeholderStart: '',
        isPinning: false,
        dropDownListCode: null,
        dropDownWindowCode: null,
        dropDownListFilters: [],
        dropDownWindowFilters: [],
        isGroupRelated: false,
        asCheckbox: false,
        asDuration: false,
        pathArray: [],
        min: -24,
        max: 48,
        timeUnit: { id: ETimeUnit.HOUR, label: ETimeUnit.HOUR },
        isFilterByObject: false,
      },
    ],
    object: null,
    visibility: true,
  }
}
